import React, { useEffect } from 'react'
import { clearChat, setCurrentConversation } from '../../../store/slices/chat';
import { useAppDispatch } from '../../../store/store';
import Chat from '../../Chat/Chat';

interface Props {
    product: any
}

export default function ConsultationsChat({ product }: Props) {
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (product?.conversation_id) {
            dispatch(setCurrentConversation({
                conversation_id: product.conversation_id,
                conversation_status: product?.conversation_status,
                conversation_title: product?.conversation_title,
                participants: []
            }))
        }
        return () => {
            dispatch(clearChat())
        }
    }, [])

    return (
        <Chat
            hideAssignBtn={true}
            chatBodyStyle={{ height: "calc(100vh - 350px)" }}
            style={{
                "border": "0px",
                "borderRadius": "0px",
            }}
        />
    )
}
